import useSWR from 'swr';

import type { ErrorWithMessage } from '../types/ErrorWithMessage';

interface OptionsResponse {
  countries: { value: string; label: string }[];
}

export const useCountryOptions = (fetchOptions = true) => {
  const { data } = useSWR<OptionsResponse, ErrorWithMessage>(
    fetchOptions ? 'options' : null,
  );

  const countries = data?.countries || [];

  return countries;
};
